import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SiteHeader from '@homeaway/react-site-header';
import { Experiment } from '../Experiment';
import { BrandConsolidationBanner } from '../Banner';
import { logExperiment } from '@homeaway/abacus-client-utils';
import { HA_IDA_CAS_HEADER_LOGIN_TEST, HA_IDA_V3_LOGIN_TEST } from './constants';

import './Header.less';

const loginRE = /(def%26service%3D){1}(.*\.com)?.*/;

class Header extends Component {
  handleLoginRedirect = () => {
    const { data: { login: { items: loginItemsArray }}} = this.props;
    const travelerLoginItem = loginItemsArray.find(item => item.cssClass === 'se-traveler-login');
    logExperiment(HA_IDA_CAS_HEADER_LOGIN_TEST);

    // CAS Login URLs need to be double encoded because of how their params are structured:
    // https://{DOMAIN}/auth/traveler/login?service=https://{DOMAIN}/exp/sso/auth?lt=traveler&context=def&service={DOUBLE_ENCODED_RETURN_URL}&kmsi=true
    let doubleEncodedURI = encodeURIComponent(encodeURIComponent(window.location.pathname + window.location.search));

    // if login, perform specific link update
    let travelerLoginURL = travelerLoginItem.link.replace(
      loginRE,
      `$1${doubleEncodedURI}&kmsi=true`
    );

    window.location.assign(travelerLoginURL);
  }

  handleLoginModal = () => {
    const { showLoginModal } = this.props;
    logExperiment(HA_IDA_CAS_HEADER_LOGIN_TEST);
    logExperiment(HA_IDA_V3_LOGIN_TEST);
    showLoginModal();
  }

  render() {
    const { siteName, locale, isTouchDevice, isInverse, isUserLogged, currency, data } = this.props;

    return (
      <React.Fragment>
        <BrandConsolidationBanner />
        {data && <Experiment name={HA_IDA_CAS_HEADER_LOGIN_TEST}>
          {value =>
            (
              <SiteHeader
                dataUrl="/node/home/api/header"
                fetchUserData={isUserLogged}
                {...{ isInverse, isTouchDevice, data, siteName, fullLocale: locale, currencyCode: currency }}
                travelerLoginClickHandler={value === 1 ? this.handleLoginModal : this.handleLoginRedirect}
                withoutCountryLanguageSelector={false}
                withoutCurrencySelector={false}
              />
            )
          }
        </Experiment>}
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  data: PropTypes.shape({
    logo: PropTypes.object,
    flags: PropTypes.object,
    scratchpad: PropTypes.object,
    login: PropTypes.object,
    travelerInbox: PropTypes.object,
    help: PropTypes.object,
    birdhouse: PropTypes.object,
    features: PropTypes.object
  }),
  isInverse: PropTypes.bool.isRequired,
  isTouchDevice: PropTypes.bool,
  isUserLogged: PropTypes.bool,
  siteName: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  currency: PropTypes.string
};

Header.defaultProps = {
  isTouchDevice: false,
  isInverse: false
};

export default Header;
